// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "" + {"218":"component---src-pages-404-tsx","691":"component---src-pages-index-tsx"}[chunkId] + "-" + {"218":"4286a6780d240e4f3b0c","691":"82d61f86aff0e3b7d240"}[chunkId] + ".js";
};